import clsx from 'clsx';

import PropTypes from 'prop-types';

import { DEFAULT_POST_CONFIG } from '@/lib/posts/defaultPostConfig';
import { getPostType, IG_POST_TYPES, STORY } from '@/lib/posts/postTypes';
//lib
import { INSTAGRAM } from '@/lib/socialProfile';

//components
import Post from '@/components/base/Post';
import HoverLabelAndAlbums from '@/components/base/Post/HoverLabelAndAlbums';

const InstagramStory = ({
    data,
    isLoading,
    config,
    openViewer,
    remoteMedia = false,
    isExport = false,
    postConfig = DEFAULT_POST_CONFIG,
    handleLabelsEvent,
    handleAlbumsEvent
}) => {
    const mergedPostConfig = { ...DEFAULT_POST_CONFIG, ...postConfig };
    const type = getPostType({ network: INSTAGRAM, type: data?.type });

    if (isLoading) {
        return <Post.Placeholder postType={STORY} isExport={isExport} />;
    }

    return (
        <Post
            data={data}
            config={config}
            isLoading={isLoading}
            className={clsx('w-full bg-white px-2 pt-2', {
                'dark:bg-icoDarkMode-anthracite': !isExport
            })}
            isExport={isExport}>
            {({ referenceElement }) => (
                <>
                    <Post.Content className="w-full">
                        {mergedPostConfig?.hasHover ? (
                            <HoverLabelAndAlbums
                                openViewer={openViewer}
                                referenceElement={referenceElement}
                                handleLabelsEvent={handleLabelsEvent}
                                handleAlbumsEvent={handleAlbumsEvent}
                                showLabels={mergedPostConfig?.showLabels}
                                showAlbums={mergedPostConfig?.showAlbums}
                                postType={STORY}
                            />
                        ) : null}
                        {type && type !== IG_POST_TYPES.TYPE_PHOTO ? (
                            <Post.PostTypeIcon type={type} />
                        ) : null}
                        {data && data?.promoted_post ? <Post.Promoted /> : null}
                        <div className="story">
                            <Post.Image remoteMedia={remoteMedia} />
                        </div>
                    </Post.Content>
                    <Post.Footer type={type} />
                </>
            )}
        </Post>
    );
};

InstagramStory.propTypes = {
    data: PropTypes.object,
    isLoading: PropTypes.bool,
    config: PropTypes.object,
    openViewer: PropTypes.func,
    addLabel: PropTypes.func,
    addAlbum: PropTypes.func
};

export default InstagramStory;
